
  export function getConfigData(){
  // return "http://192.168.1.141:58865";
    return '/GDUTMobileApi';
  }


  export function getCorporationId(){
    return "16";
  }

  export function isWx(){
    return true;
  }




// WEBPACK FOOTER //
// ./src/utils/serverConfig.js